import { Button, CheckSVG, TrashHollowSVG } from "@newsela/angelou";

import { withTrackEvent } from "@newsela/snitch";
import { IGuidedHighlightingQuestion } from "@/view/utils/useGuidedHighlightingStudent/types";

import {
  buttonsWrapper,
  buttonCss,
} from "./GuidedHighlightingStudentSkillQuestion.style";

const ButtonWithTrackEvent = withTrackEvent(
  Button,
) as React.ForwardRefExoticComponent<
  React.ComponentProps<typeof Button> & React.RefAttributes<HTMLButtonElement>
>;

interface CheckCleanButtonsProps {
  activeGuidedHighlightingQuestion: IGuidedHighlightingQuestion | undefined;
  handleCleanHighlighting: () => void;
  handleCheckHighlight: () => void;
}

const CheckCleanButtons = ({
  activeGuidedHighlightingQuestion,
  handleCleanHighlighting,
  handleCheckHighlight,
}: CheckCleanButtonsProps) => {
  const eventPropertiesClear = {
    objectType: "User",
    actionName: "Interact",
    event_type: "click",
    streamProperties: {
      component_type: "ClearStudentCardButton",
      description:
        "Clear student response for the active Guided Highlighting question",
    },
  };

  const eventPropertiesCheck = {
    objectType: "User",
    actionName: "Interact",
    event_type: "click",
    streamProperties: {
      component_type: "CheckStudentCardButton",
      description:
        "Validate student response for the active Guided Highlighting question",
    },
  };
  return (
    <div css={buttonsWrapper}>
      <ButtonWithTrackEvent
        __cssFor={{ root: buttonCss }}
        {...eventPropertiesClear}
        icon={{
          SvgComponent: TrashHollowSVG,
          alignment: Button.iconAlignments.left,
        }}
        flavor={Button.flavors.secondary}
        disabled={!activeGuidedHighlightingQuestion}
        onClick={handleCleanHighlighting}
        dataProps={{
          "data-qa-selector": "guided-highlighting-clear-student-response",
        }}
      >
        Clear
      </ButtonWithTrackEvent>
      <ButtonWithTrackEvent
        __cssFor={{ root: buttonCss }}
        {...eventPropertiesCheck}
        icon={{ SvgComponent: CheckSVG, alignment: Button.iconAlignments.left }}
        flavor={Button.flavors.primary}
        disabled={!activeGuidedHighlightingQuestion?.selectedText}
        dataProps={{
          "data-qa-selector": "guided-highlighting-validate-student-response",
        }}
        onClick={handleCheckHighlight}
      >
        Check
      </ButtonWithTrackEvent>
    </div>
  );
};
export default CheckCleanButtons;
